//--------------------------------------------
//
// Takes In Messages and Makes Them Really Big
// will incorporate some custom roll of inflated text
//--------------------------------------------

'use strict';


const COLORS = [
	'rgba(255,0,255,1)',
	'rgba(0,255,0,1)',
	'rgba(255,0,0,1)',
	'rgba(0,255,255,1)',
	'rgba(255,255,0,1)'
];

const TextExplode = (text) => {

	const container = document.getElementById('welcome');
	container.classList.remove('gone');

	const textToDisplay = text || 'WELCOME';

	container.style.color = COLORS[Math.floor(Math.random() * COLORS.length)];

	container.textContent = textToDisplay;

	setTimeout(() => {
		container.classList.add('gone');

		setTimeout(() => {
			container.innerHTML = '';
		},1000);

	}, 500);
}

export default TextExplode;